// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/node_modules/.pnpm/@umijs+renderer-react@4.6.9_d307d29eae6a5f51118823a763fbdedb/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
